<template>
  <div class="container" style="overflow:visible">
    <div class="activity" @click="handleAddtime">
      <van-list
        v-model="dataList.loading"
        :finished="dataList.finished"
        finished-text="没有更多了"
        @load="Search"
      >
        <!-- <van-cell v-for="item in list" :key="item" :title="item" /> -->
        <div class="card" v-for="(v) in dataList.list" :key="v.id">
          <div class="actbg" @click="goBuy(v)">
            <img :src="v.img" alt />
            <div class="actbgtag">
              <span>{{v.typeName}}</span>
              <!-- format="DD天HH:mm:ss" -->
              <van-count-down :time="v.endTimeStemp" format="DD天HH时mm分ss秒" />
            </div>
          </div>
          <div class="btnbox">
            <p>{{v.title}}</p>
            <!-- 活动类型 1优惠活动-车主 3拼团活动 4秒杀活动 -->
            <van-button class="checkorder" size="small" @click="goBuy(v)" v-if="v.type===1">立即购买</van-button>
            <van-button class="checkorder" size="small" @click="goBuy(v)" v-if="v.type===3">立即拼团</van-button>
            <van-button class="checkorder" size="small" @click="goBuy(v)" v-if="v.type===4">马上秒杀</van-button>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "store",
  computed: {
    ...mapState({
      UserInfo: state => state.UserInfo
    })
  },
  data () {
    return {
      time: 30 * 60 * 60 * 1000,
      active: 0,
      showArea: false,
      position: 1,
      showSort: false,
      sort: 1,
      showFilter: false,
      selectedFilters: [[1, 0, 0], [1, 2], [1]],
      dataList: {
        current: 1,
        size: 10,
        list: [],
        empty: 0,
        finished: false,
        loading: false // 异步加载状态
      },
      query: {},
      times: 0,
      addNum: 1
    };
  },
  methods: {
    handleAddtime () {
      if (this.times > 20) {
        console.log('++', this.times, this.addNum);
        // window.eruda.init();
        if (this.addNum === 1) {
          (function () {
            var script = document.createElement("script");
            script.src = "//cdn.jsdelivr.net/npm/eruda";
            document.body.appendChild(script);
            script.onload = function () {
              window.eruda.init();
            };
          })();
          this.addNum = 2;
        }
        return;
      }
      this.times += 1;
    },
    resetShowModuls () {
      this.active = 0;
    },
    handleClickFilter (type) {
      this.active = type;
      this.showArea = false;
      this.showSort = false;
      this.showFilter = false;
      switch (type) {
        case 1:
          this.showArea = true;
          break;
        case 2:
          this.showSort = true;
          break;
        case 3:
          this.showFilter = true;
          break;
        default:
          this.showArea = false;
          break;
      }
    },
    handlePositionChange (it, i) {
      console.log(it, i);
      // 赋值展示
      this.position = it;
      // 关闭弹出
      this.showArea = false;
      // 恢复tab选中
      this.active = 0;
    },
    handleSortChange (it, i) {
      // 赋值展示
      this.sort = it;
      // 关闭弹出
      this.showSort = false;
      // 恢复tab选中
      this.active = 0;
    },
    // 监听filter列表中的变更
    handleFitlerTypeChange (i, val) {
      if (this.selectedFilters[i][val] === 0) {
        this.$set(this.selectedFilters[i], val, 1);
      } else {
        this.$set(this.selectedFilters[i], val, 0);
      }
    },
    handleFilterConfirm () {
      this.showFilter = false;
      // 在这里查询数据
    },
    goBuy (v) {
      // console.log('123', v);
      switch (v.type) {
        case 1:
          this.go(`/Activity/Normal?id=${v.id}&activityNum=${v.activityNum}&saleNum=${v.saleNum}`);
          break;
        case 3:
          this.go(`/Activity/Tuan?id=${v.id}&activityNum=${v.activityNum}&saleNum=${v.saleNum}`);
          break;
        case 4:
          this.go(`/Activity/Normal?id=${v.id}&activityNum=${v.activityNum}&saleNum=${v.saleNum}`);
          break;
        default:
          break;
      }
    },
    async Search () {
      if (!this.query.type) {
        await this.generalList();
      } else if (this.query.type && this.query.shareShopId) {
        await this.shopActivityList();
      } else {
        console.log("缺少必要参数");
      }
    },
    async generalList () {
      // activity/activity/generalList
      try {
        this.loading = true;
        let pageJson = {
          page: this.dataList.current,
          limit: this.dataList.size
        };
        let form = {};
        let result = await this.request("/activity/activity/generalList", {
          ...pageJson,
          ...form
        });
        result.List = result.List.map(it => {
          return {
            ...it,
            typeName: this.activityTypeFilter(it.type),
            endTimeStemp: this.toTimeStamp(it.endTime) - new Date().getTime()
          };
        });
        if (this.dataList.current === 1) this.dataList.list = result.List;
        else this.dataList.list = [...this.dataList.list, ...result.List];
        this.$nextTick(() => {
          if (result.List.length < result.TotalCount) {
            this.dataList.current++;
          }
          this.dataList.loading = false;
          // 数据全部加载完成
          if (this.dataList.list.length >= result.TotalCount) {
            this.dataList.finished = true;
          }
        });

        // this.tablePage.datalist = result.List;
        // this.tablePage.TotalCount = result.Paging.TotalCount;
        this.loading = false;
      } catch (e) {
        this.loading = false;
        this.$error(e.message);
      }
    },
    // shop/shop/activityList
    async shopActivityList () {
      try {
        this.loading = true;
        let pageJson = {
          page: this.dataList.current,
          limit: this.dataList.size
        };
        let form = {};
        let result = await this.request("/shop/shop/activityList", {
          ...pageJson,
          ...form,
          ...this.query
        });
        result.List = result.List.map(it => {
          return {
            ...it,
            typeName: this.activityTypeFilter(it.type),
            endTimeStemp: this.toTimeStamp(it.endTime) - new Date().getTime()
          };
        });
        if (this.dataList.current === 1) this.dataList.list = result.List;
        else this.dataList.list = [...this.dataList.list, ...result.List];
        this.$nextTick(() => {
          if (result.List.length < result.TotalCount) {
            this.dataList.current++;
          }
          this.dataList.loading = false;
          // 数据全部加载完成
          if (this.dataList.list.length >= result.TotalCount) {
            this.dataList.finished = true;
          }
        });

        // this.tablePage.datalist = result.List;
        // this.tablePage.TotalCount = result.Paging.TotalCount;
        this.loading = false;
      } catch (e) {
        this.loading = false;
        this.$error(e.message);
      }
    }
  },
  mounted () {
    this.removeStore('tuan');
    this.removeStore('tuanId');
    // this.Search();
    this.query = {
      ...this.$route.query,
      type: parseInt(this.$route.query.type)
    };
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/css/style";

.container {
  background: @bgGray;
  overflow: auto;
  .activity {
    padding-top: 0.26rem;
    padding-bottom: 0.27rem;
  }
  .card {
    background: #fff;
    width: 8.93rem;
    margin: 0.27rem auto 0;
    box-shadow: 0rem 0rem 0.27rem 0rem rgba(210, 210, 210, 0.5);
    padding: 0.37rem;
    box-sizing: border-box;
    border-radius: 0.13rem;
    .actbg {
      position: relative;
      width: 8.16rem;
      height: 6.667rem;
      margin: 0 auto;
      overflow: hidden;
      border-radius: 0.13rem;
      img {
        width: 100%;
        height: 100%;
      }
      .actbgtag {
        position: absolute;
        left: 0;
        top: 0;
        border-top-left-radius: 0.13rem;
        border-bottom-right-radius: 0.32rem;
        background: #ff8c3e;
        text-align: center;
        height: 0.61rem;
        line-height: 0.61rem;
        padding: 0 8px;
        .sc(0.32rem, #fff);
        .flex-center();
        justify-content: space-between;
        .van-count-down {
          margin-left: 5px;
          .sc(0.32rem, #fff);
        }
      }
    }
    .btnbox {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 0.4rem;
      p {
        font-size: 0.37rem;
      }
      .checkorder {
        background: #ff8c3e;
        color: #fff;
        border-radius: 0.08rem;
        width: 1.9rem;
      }
    }
  }
}
</style>